exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-modal.cap-modal-v2{max-width:372px}.ant-modal.cap-modal-v2 .ant-modal-header{border-bottom:none}.ant-modal.cap-modal-v2 .ant-modal-body{padding-top:.285rem;padding-bottom:0}.ant-modal.cap-modal-v2 .ant-modal-footer{border-top:none;padding-bottom:1.714rem}.ant-modal.cap-modal-v2 .ant-modal-footer .default-footer{display:flex}.ant-modal.cap-modal-v2 .ant-modal-close-icon{color:#091e42}\n", ""]);

// exports
